import { AbstractControl, ValidationErrors } from '@angular/forms';

export function ValidatePasswords(control: AbstractControl): ValidationErrors | null {
  if (control.get('password').value !== control.get('confirmPassword').value) {
    return { non_matching_passwords: true };
  }

  return null;
}
